import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { reaction } from "mobx";

import {Form, Input, Modal, Select} from "antd";

import FormButtons from "../../../commonComponents/FormButtons";

import ModalValidationError from "../../../commonComponents/ModalValidationError";

const FormItem = Form.Item;

@withRouter
@inject("profileStore", "translationsStore", "step0RegistrationStore", "usersStore")
@observer
class Step_0_Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      modalVisible: false,
      fit2youImei: null
    };

    props.step0RegistrationStore.setFormField('vehicleType', 'car');

    reaction(
      () => props.step0RegistrationStore.vehicleType,
      vehicleType => {

        this.props.form.resetFields('imei');
        this.props.form.resetFields('plate');
        this.props.step0RegistrationStore.setImei();
        this.props.step0RegistrationStore.setPlate();

        this.loadAssets(vehicleType);
      }
    );
  }

  setFieldsValue() {
    this.props.form.setFieldsValue(this.props.step0RegistrationStore.formValues);
  }

  componentDidMount() {
    this.props.step0RegistrationStore.setImei();
    this.props.step0RegistrationStore.setPlate();
    this.props.step0RegistrationStore.setVehicleType();
    this.setFieldsValue();
    this.loadAssets();
  }

  loadAssets = (vehicleType = 'car') => {
    this.props.profileStore.pullUser().then(() => {
      this.setState({
        devices: this.props.profileStore.devicesWithVehicleType
          .filter(asset => asset.vehicleType === vehicleType)
          .map(a => a.imei)
          .map(d => {
            return {
              key: d,
              text: d,
              value: d
            };
          })
          .sort((d1, d2) => d1.value - d2.value)
      });
    });
  }

  handlerOnExit = e => this.props.history.push("/registrations");

  handlerOnSubmit = e => {
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
          const activeInsurance = await this.props.step0RegistrationStore.getFit2YouPolicy()
          if(
              activeInsurance &&
              activeInsurance.attributes.key_sat &&
              activeInsurance.attributes.key_sat !== this.props.step0RegistrationStore.imei
          ) {
              this.setState({modalVisible: true, fit2youImei: activeInsurance.attributes.key_sat})
          } else {
              this.submit()
          }
      }
    });
    e.preventDefault();
  };

  submit = () => {
    this.props.step0RegistrationStore
      .submit()
      .then(() => {
          this.props.history.push("/registration/step_1");
      })
      .catch(e => {
          ModalValidationError(e.details);
      });
  }

  handlerOnChange = field => e => {
    const value = typeof e === "string" ? e : e.target.value;
    this.props.step0RegistrationStore.setFormField(field, value);
  };

  handlerModalOk = () => {
    this.setState(
        {modalVisible: false},
        () => this.submit()
      )
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { current: t } = this.props.translationsStore;
    const { inProgress, isValid } = this.props.step0RegistrationStore;
    const { vehicleType } = this.props.step0RegistrationStore.formValues || {};

    return (
      <Form name="step_0" onSubmit={this.handlerOnSubmit}>
        <FormItem>
          {getFieldDecorator("vehicleType", {
            rules: [
              { required: true },
              {
                type: "string",
                message: 'Required'
              }
            ],
            initialValue: "car"
          })(<Select placeholder={t["shared"]["lblVehicleType"]} onChange={this.handlerOnChange("vehicleType")} disabled={inProgress}>
            {['car', 'motorbike'].map(vehicleType => {
              return (
                <Select.Option value={vehicleType} key={vehicleType}>
                  {t["shared"]["VehicleTypes"][vehicleType]}
                </Select.Option>
              );
            })}
          </Select>)}
        </FormItem>
        <FormItem>
          {getFieldDecorator("imei", {})(
            <Select placeholder={t["registration_0"]["lblImeiOption1"]} onChange={this.handlerOnChange("imei")} disabled={inProgress} showSearch={true}>
              {this.state.devices &&
                this.state.devices.map(device => {
                  return (
                    <Select.Option value={device.value} key={device.key}>
                      {device.text}
                    </Select.Option>
                  );
                })}
            </Select>
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("plate", {
            rules: [
              { required: true },
              {
                type: "string",
                pattern: vehicleType === 'motorbike' ? /^[a-zA-Z]{2}[0-9]{5}$/i : /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/i,
                message: `Is not a valid plate (${vehicleType === 'motorbike' ? 'AA12345' : 'AA123ZZ'})`
              }
            ]
          })(<Input type="text" placeholder={t["shared"]["lblPlate"]} onChange={this.handlerOnChange("plate")} disabled={inProgress} />)}
        </FormItem>
        <FormButtons
          lblExit={t["shared"]["btnExit"]}
          lblContinue={t["shared"]["btnContinue"]}
          isValid={() => isValid}
          inProgress={inProgress}
          handlerOnSubmit={this.handlerOnSubmit}
          handlerOnExit={this.handlerOnExit}
        />
        <Modal
            title={t["registration_0"]["modalImeiTitle"]}
            visible={this.state.modalVisible}
            onOk={this.handlerModalOk}
            onCancel={() => this.setState({modalVisible: false})}
        >
            {t["registration_0"]["modalImeiTxt1"]}{this.state.fit2youImei}{t["registration_0"]["modalImeiTxt2"]}
        </Modal>
      </Form>
    );
  }
}

export default Form.create()(Step_0_Form);



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_0/Step_0_Form.js